var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-default btn-bold btn-upper btn-font-sm",attrs:{"type":"button"},on:{"click":function($event){return _vm.onButtonClicked()}}},[_c('i',{class:_vm.buttonIcon}),_vm._v(" "+_vm._s(_vm.buttonText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }